import { all, put, takeLatest } from 'redux-saga/effects';
import {
  showLoading,
  hideLoading,
  showPullToRefresh,
  hidePullToRefresh
} from '../../actions/Login/action';
import {
  updateFavoriteDataReducer,
  updateFavoriteError
} from '../../actions/Favorite/action';
import * as constants from '../../utils/constants';
import request from '../../utils/request';
import { DomainConverter } from '../../utils/common';

// handle the API call for updating the search, and handling duplicate/List full errors
export function* updateFavoriteDataFunc(action: any) {
  const { isHideLoader } = action && action.payload && action.payload;
  try {
    if (!(action && action.payload && isHideLoader)) {
      yield put(showLoading());
    }
    yield put(showPullToRefresh());
    const updatefavoritemutation = DomainConverter.domainToData<any>(
      action.payload.data
    );
    const fetchFavoriteResults = yield request<any>([
      'FAVORITE',
      'FAVORITE_LOADS',
      null,
      '',
      updatefavoritemutation,
      'application/json'
    ]);
    const errorMessage = getErrorMessage(fetchFavoriteResults);
    if (errorMessage) {
      yield put(updateFavoriteError(fetchFavoriteResults));
    }
    const id = fetchFavoriteResults.data.updateUserSearchHistoryAsFavorite ? fetchFavoriteResultsCheck(fetchFavoriteResults) : fetchFavoriteResultsHistory(fetchFavoriteResults);
    if (id) {
      yield put(updateFavoriteDataReducer(id));
    }
    if (!(action && action.payload && isHideLoader)) {
      yield put(hideLoading());
    }
    yield put(hidePullToRefresh());
  } catch (e) {
    if (!(action && action.payload && isHideLoader)) yield put(hideLoading());
    yield put(hidePullToRefresh());
  }
}

function fetchFavoriteResultsHistory(fetchFavoriteResults: any) {
  return fetchFavoriteResults.data.updateUserSearchHistory && fetchFavoriteResults.data.updateUserSearchHistory.id||null;
}

function fetchFavoriteResultsCheck(fetchFavoriteResults: any) {
  return fetchFavoriteResults.data.updateUserSearchHistoryAsFavorite.userSearchHistory && fetchFavoriteResults.data.updateUserSearchHistoryAsFavorite.userSearchHistory.id|| null;
}

function getErrorMessage(fetchFavoriteResults: any) {
  return fetchFavoriteResults.data.updateUserSearchHistoryAsFavorite && fetchFavoriteResults.data.updateUserSearchHistoryAsFavorite.errorMessage || null;
}

export default function* rootSaga() {
  yield all([
    takeLatest(constants.UPDATE_FAVORITE_LOADS, updateFavoriteDataFunc)
  ]);
}
